import request from 'superagent';
import {store, history } from '/app/src/store';
import Model from '../model';
import * as actions from './actions';
import ConversationModel from '../Conversation/model';

import CustomerModel from '../Customer/model';
import UserSelector from './selector'
import CompanyModel from '../Company/model';
import EmployeeModel from '../Employee/model';
import { toast } from 'react-toastify';
import {promptPermission} from '/app/src/lib/WebNotification/notification'

class User extends Model {

    resetPassword(email) {
        let url = this.url();

        return request
        .put(`${url}/v1/employee/password/reset`)
        .accept('application/json')
        .set('Content-Type', 'application/json')
        .send({
            user_email: email
        })
    }

    resetVerificationMail(email) {
        let url = this.url();
        return request
        .post(`${url}/v2/employee/verification/reset`)
        .accept('application/json')
        .set('Content-Type', 'application/json')
        .send({
            user_email: email
        })
    }
    // when we refresh the website
    // or making sure the info is up to date in bulk
    // we can do this, also retrieve a new token
    // TODO: when we reconnect, we should be selective innstead of use this info
    getInitialData(noRedirect){
        let url = this.url();
        let token = this.token();
        this._success = (dispatch, err, res) => {
            let body = res.body;
            let company = body.company;
            dispatch(CompanyModel.put(body.company)); //Fetching items from store
            dispatch(EmployeeModel.puts(body.employees)); //Fetching items from store

            dispatch(actions.userFetchedInitialDataSuccess(body.token))
            const state = store.getState();
            // making sure this is not a reconnect event
            if(state.getIn(['user', 'initialData', 'isFetched']) === 1){
                if(body.role === 'admin'){
                    const payment_status = company['payment_status']
                    if(payment_status['status'] === 'trial'){
                        const days_left = payment_status['days_left_in_trial']
                        if(days_left > 0 ){
                            toast.info('Du har ' + days_left + ' dagar kvar in trial.')
                        }else{
                            toast.info('Idag är sista dagen in trial.')
                        }
                    }else if(payment_status['status'] === 'trial_end'){
                        toast.warning(
                            'Din trialperiod är över och ClientChat har därför tagits bort från din hemsida. För att fortsätta använda Jibber, var vänlig och skriv in din faktureringsuppgifter i Företagsinställningar/Faktureringsuppgifter'
                        )
                    }else if(payment_status['status'] === 'late'){
                        toast.warning(
                            'Vi har inte tagit emot någon betalning från er. ClientChat har därför temporärt tagits bort från er hemsida och kommer att aktiveras igen när fakturan är betald.'
                        )
                    }else if(payment_status['status'] === 'cancel'){
                        toast.warning(
                            'Företag finns inte längre kvar!'
                        )
                    }
                }
            }
        }

        this._failure = (dispatch, err, res) => {
            dispatch(actions.userFetchedInitialDataFailed());
            history.push('/')
        }

        return (dispatch) => {
            dispatch(actions.userFetchingInitialData());
            request
            .post(`${url}/v2/me/token`)
            .accept('application/json')
            .send({
                token: token
            })
            .end(this.handleResponse(dispatch));
        }

    }

    login(username, password, errorFunction){
        this._success = (dispatch, err, res) => {
            let body = res.body;
            const userId = body.current_user.id;
            const userToken = body.current_user.token;
            dispatch(actions.userLoginSuccess(userId, userToken));
        }

        this._failure = (dispatch, err, res) => {
            errorFunction(res);
            dispatch(actions.userLoginFailure(res));
        }

        return (dispatch) => {
            let url = this.url();
            request
            .post(`${url}/v2/me/login`)
            .accept('application/json')
            .send({
                user_email: username,
                user_password: password
            })
            .end(this.handleResponse(dispatch));
        }
    }


    claimingTicket(room) {
        return (dispatch) => {
            var url = this.url()
            let token = this.token()
            request
            .put(`${url}/v1/ticket/assigned`)
            .accept('application/json')
            .send({room: room})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    //this now done by socket
//                    this.socket().emit('join_conversation', room, token, 'employee');
//                    // TODO Socket should return the conversation info from here
//                    this.socket().once('joined', () => {
//                        dispatch(ConversationModel.setType(room, 'assigned'));
//                    });
                }
            });
        }
    }

    resolveTicket(room) {
        return (dispatch) => {
            let url = this.url()
            let token = this.token()
            request
            .put(`${url}/v1/ticket/resolved`)
            .accept('application/json')
            .send({room: room})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {

                if (res.statusCode === 200) {
                    //socket.emit('leave_conversation', room, token, 'employee');
                    //dispatch(ConversationModel.remove(room));
                    dispatch(ConversationModel.setType(room, 'resolved'));
                    history.push('/')
                }
            });
        }
    }

    transferTicket(room, coworker, customerName) {
        return (dispatch) => {

            let url = this.url();
            let token = this.token();
            let coworkerId = coworker.id
            let socket = this.socket();


            request
            .put(`${url}/v1/ticket/transfer`)
            .accept('application/json')
            .send({room: room, coworker_id: coworkerId})
            .set('Authorization', 'Bearer ' + token)
            .end((err, res) => {
                if (res.statusCode === 200) {
                    socket.emit('leave_conversation', room, token, 'employee');

                    store.dispatch(ConversationModel.setType(room, 'invalid'));
                    store.dispatch(ConversationModel.setMetaInfo(room, 'Ärendet överfördes till ' + coworker.name));
                    toast.success(`Ärendet med ${customerName} överfördes till ${coworker.name}.`)
                    history.push('/')
                }
                if (res.statusCode === 401) {
                    socket.emit('leave_conversation', room, token, 'employee');

                    store.dispatch(ConversationModel.setType(room, 'invalid'));
                    history.push('/')
                }
            });
        }
    }

    searchBy(tags, offset=1) {
        return (dispatch => {
            const url = this.url();
            dispatch(actions.userFetchingSearchResults());
            const token = this.token();
            return request
                .post(`${url}/v1/tag/get`)
                .accept('application/json')
                .send({
                    tags: tags,
                    offset: offset-1
                })
                .set('Authorization', 'Bearer ' + token)
                .end((err, res) => {
                    if (res.statusCode === 200) {
                        dispatch(actions.userFetchingSearchResultsSuccess(res.body));
                        const state = store.getState();
                        //Customer redux state is an associative array (not a list).
                        const mappedCustomers = {};
                        const searchHitsCustomer = UserSelector.searchResults(state).get('customers');
                        searchHitsCustomer.map((customer) => {mappedCustomers[customer.get('id')] = customer; return false});
                        dispatch(CustomerModel.puts(mappedCustomers));

                        const mappedTickets = {};
                        const searchHitsTicket = UserSelector.searchResults(state).get('tickets');
                        searchHitsTicket.map((ticket) => {mappedTickets[ticket.get('room')] = ticket; return false});
                        //Set finished since only finished can be searched on.
                        dispatch(ConversationModel.puts(mappedTickets, 'resolved'));
                    }
                })
        })
    }

    logout(){
        return (dispatch) => {
            dispatch(actions.userLogout());
            history.push('/')
        }
    }

    //================= NOTIFICATIONS =====================
    muteNotifications(toggle){
        return ((dispatch) => {
            if (toggle) dispatch(actions.soundOn());
            else dispatch(actions.soundOff());
        })
    }

    //notifyOnDenied: if true, notifies user that web notifications are blocked with an alert().
    killNotifications(toggle, notifyOnDenied=false){
        return (async (dispatch) => {
            if (toggle) {
                if (await promptPermission(notifyOnDenied)) dispatch(actions.webNotificationOn());
            }
            else dispatch(actions.webNotificationOff());
        })
    }
}


export default new User();


// WEBPACK FOOTER //
// ./src/model/User/model.js